import type { PayoffDeliveryMethod } from '@ld.consumer-portal/models';
import type { PayoffDateConstraints, PayoffDateConstraintStrategy } from './date-constraint-strategy';
import { createDateFromToday } from './payoff-date.utils';

const DEFAULT_MAX_DAYS = 29;

export class DefaultDateConstraintStrategy implements PayoffDateConstraintStrategy {
  getConstraints(deliveryMethod: PayoffDeliveryMethod): PayoffDateConstraints {
    return {
      minDate: createDateFromToday(0),
      maxDate: createDateFromToday(DEFAULT_MAX_DAYS),
      isDatePickerDisabled: deliveryMethod === 'Mail',
    };
  }
}
